export const OPEN_DIALOGUE = "OPEN_DIALOGUE";
export const CLOSE_DIALOGUE = "CLOSE_DIALOGUE";



export const OPEN_NOTIFICATION_DIALOGUE = "OPEN_NOTIFICATION_DIALOGUE"
export const CLOSE_NOTIFICATION_DIALOGUE = "CLOSE_NOTIFICATION_DIALOGUE"

